export default "__VITE_ASSET__DVklO0HG__"